import { render, staticRenderFns } from "./DialogViewFile.vue?vue&type=template&id=b3b6c154"
import script from "./DialogViewFile.vue?vue&type=script&lang=js"
export * from "./DialogViewFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports